import React, { Component } from "react";
import UserThumb from "../../assets/user-thumb.png";
import Input from "../../components/Input";
import Rating from "react-rating";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import Select from "react-select";
import { observer } from "mobx-react";
import voiceStore from "../../stores/voiceStore";
import projectStore from "../../stores/projectStore";

const AddNewTalentStep1 = observer(
  class AddNewTalentStep1 extends Component {
    constructor(props) {
      super(props);
      this.state = {
        talentName: "",
        mobileNo: "",
        email: "",
        dob: null,
        socialAccounts: "",
        nationality: "",
        accents: null,
        notes: "",
        rating: 0,
        fee: "",
        image: null,
      };
    }

    handleAccentsSelect = (data) => {
      this.setState({ accents: data });
    };

    handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = 400;
          canvas.height = 400;

          ctx.drawImage(img, 0, 0, 400, 400);

          canvas.toBlob((blob) => {
            const newFile = new File(
              [blob],
              `${file.lastModified}-${Math.floor(
                Math.random() * 99999
              )}.${file.name.split(".").pop()}`,
              {
                type: file.type,
                lastModified: file.lastModified,
              }
            );
            this.setState({ image: newFile });
          }, file.type);
        };
      }
    };

    componentDidMount() {
      this.setState({ ...voiceStore.step1Values });
    }

    validateFields = () => {
      const { talentName, mobileNo, email } = this.state;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phonePattern = /^\+?[0-9\s-]*$/;

      return (
        talentName.trim() !== "" && // Talent Name is still mandatory
        (mobileNo.trim() === "" || phonePattern.test(mobileNo)) && // Validate phone number if provided
        (email.trim() === "" || emailPattern.test(email)) // Validate email if provided
      );
    };

    render() {
      const {
        talentName,
        mobileNo,
        email,
        dob,
        socialAccounts,
        nationality,
        accents,
        notes,
        rating,
        fee,
        image,
      } = this.state;

      const accentsOptions = voiceStore.dropdownData.accentOptions;

      return (
        <div className="flex flex-col z-10">
          <span className="font-normal text-lg text-[#21272A] my-2">
            Profile Photo
          </span>
          <div className="flex flex-1 flex-row">
            <div className="flex flex-row items-center gap-6">
              {image ? (
                <img
                  src={URL.createObjectURL(image)}
                  className="w-[100px] h-[100px] rounded-full"
                  alt="Profile"
                />
              ) : (
                <img
                  src={UserThumb}
                  className="w-[100px] h-[100px] rounded-full"
                  alt="Profile"
                />
              )}
              <div className="flex flex-col justify-center items-center">
                <button
                  onClick={() => document.getElementById("fileInput").click()}
                  className="border-[2px] px-4 py-2 border-[#000000] text-base font-normal text-[#000000]"
                >
                  Upload Photo
                </button>
                <input
                  id="fileInput"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={this.handleFileChange}
                />
                <button
                  onClick={() => this.setState({ image: null })}
                  className="text-base font-normal text-[#000000] mt-2"
                >
                  remove
                </button>
              </div>
            </div>
            <div className="w-[1px] h-full bg-[#DDE1E6] mx-12 hidden lg:flex"></div>
            <div className="flex-1 flex-col hidden lg:flex">
              <span className="text-lg font-normal text-[#21272A]">
                Image requirements:
              </span>
              <span className="text-sm font-normal text-[#21272A] mt-2">
                - Your face or company logo
              </span>
            </div>
          </div>

          <div className="h-[1px] w-full bg-[#DDE1E6] mt-6"></div>
          <span className="font-normal text-lg text-[#21272A] my-2">
            Talent Details
          </span>

          <div className="flex flex-col lg:flex-row gap-4">
            <Input
              title="Talent Name"
              onChange={(e) => this.setState({ talentName: e.target.value })}
              value={talentName}
            />
          </div>

          <div className="flex flex-col lg:flex-row gap-4">
            <Input
              type="tel"
              title="Phone Number"
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength={13}
              onChange={(e) => this.setState({ mobileNo: e.target.value })}
              value={mobileNo}
            />
            <Input
              type="email"
              title="E-mail"
              onChange={(e) => this.setState({ email: e.target.value })}
              value={email}
            />
          </div>

          <div className="flex flex-col lg:flex-row gap-4">
            <div className="flex flex-1 flex-col justify-center">
              <div className="flex flex-1">
                <Input
                  title="Birthday"
                  onChange={(e) => this.setState({ dob: e.target.value })}
                  type="date"
                  value={dob}
                />
              </div>
            </div>
            <Input
              title="Social Accounts"
              onChange={(e) =>
                this.setState({ socialAccounts: e.target.value })
              }
              value={socialAccounts}
            />
          </div>

          <div className="flex flex-col lg:flex-row gap-4">
            <Input
              title="Nationality"
              onChange={(e) => this.setState({ nationality: e.target.value })}
              value={nationality}
            />
            <div className="flex flex-1 flex-col justify-center">
              <span className="text-sm font-normal text-[#21272A] my-2">
                Accents
              </span>
              <Select
                options={accentsOptions}
                placeholder="Select..."
                value={accents}
                onChange={this.handleAccentsSelect}
                isSearchable={true}
                isMulti
                styles={{
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F0EFEF",
                    paddingTop: 5,
                    paddingBottom: 5,
                    boxShadow: "none",
                    border: "1px solid #ccc",
                    "&:hover": {
                      border: "1px solid #ccc",
                    },
                  }),
                  indicatorsContainer: (provided) => ({
                    ...provided,
                    display: "none",
                  }),
                }}
              />

              <div className="flex flex-row mt-2 items-center">
                <span className="text-xs font-normal text-[#21272A]">
                  Couldn't find the accent you were looking for?
                </span>
                <button
                  onClick={() => {
                    projectStore.setAddTagsModalVisible(true);
                  }}
                  className="text-xs font-normal text-[#21272A] underline ml-1"
                >
                  Add New
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-1 flex-col lg:flex-row gap-4">
            <div className="flex flex-1">
              <Input
                title="Fee"
                onChange={(e) => this.setState({ fee: e.target.value })}
                value={fee}
              />
            </div>

            <div className="flex flex-1 flex-col justify-center">
              <span className="text-sm font-normal text-[#21272A] my-2">
                Rating
              </span>
              <Rating
                emptySymbol={<FaRegStar size={24} />}
                fullSymbol={<FaStar size={24} />}
                halfSymbol={<FaStarHalfAlt size={24} />}
                fractions={2}
                onChange={(rate) => this.setState({ rating: rate })}
                initialRating={rating}
              />
            </div>
          </div>

          <Input
            type="textarea"
            title="Notes"
            onChange={(e) => this.setState({ notes: e.target.value })}
            value={notes}
          />

          <div className="mt-4 flex justify-end gap-2 pb-10">
            <button
              disabled={!this.validateFields()}
              className={`text-white font-medium text-base px-6 py-2 rounded-md ${
                this.validateFields() ? "bg-[#130D0D]" : "bg-gray-400"
              }`}
              onClick={() => {
                voiceStore.setStep1Values(this.state);
                voiceStore.nextStep();
              }}
            >
              Next
            </button>
          </div>
        </div>
      );
    }
  }
);

export default AddNewTalentStep1;
